export const APPROVER_ROLE_ID = 7;
export const CONFIGURATION_SAVE_SUCCESS = "Configuration saved successfully";
export const PENDING_RULE_MESSAGE =
  "Can't change settings because some Rules for this Agency are triggered. Orders that triggered them might be with statuses Ready for Approval or Order change, and not yet visible in Additional Approval overview.";
